import { useMutation } from '@tanstack/react-query';
import { customFetchV2 } from '../services/custom-fetch-v2';

interface UpdateUserNameRequest {
  firstName: string;
  lastName: string;
}

interface UpdateUserNameResponse {
  firstName: string;
  lastName: string;
}

const updateUserName = async (
  request: UpdateUserNameRequest,
): Promise<UpdateUserNameResponse> => {
  const response = await customFetchV2<UpdateUserNameResponse>('/api/v2/users/me', {
    method: 'PATCH',
    body: JSON.stringify(request),
  });

  if (!response.ok) {
    throw new Error('Unable to update user name');
  }

  return response.data;
};

const useUpdateUserNameMutation = () => useMutation({
  mutationFn: updateUserName,
});

export { useUpdateUserNameMutation };
